<div class="thank-you-container container position-relative">
    <h1>
        {{ "Gracias por tu compra" | translate }}
    </h1>
    <h2>
        {{ "En breve recibirás los datos de tu reserva y el bono de tu experiencia mediante correo electronico." |
        translate }}
    </h2>
    <div class="background">
        <img src="../../../assets/venntur-isotype-70.png" alt="Venntur logo">
    </div>
</div>